import { create } from 'zustand';

const useStore = create((set) => ({
  user: null,
  household: null,
  featureFlags: {},
  setUser: (user) => set({ user }),
  setHousehold: (household) => set({ household }),
  setFeatureFlags: (flags) => set({ featureFlags: flags }),
  logout: () => set({ user: null, household: null })
}));

export default useStore;
